<template>
  <div
    v-if="show"
    class="required-fields-message font-14-400"
    :style="{ width }"
  >
    {{ computedMessage }}
  </div>
</template>

<script>
export default {
  name: "FieldsErrorMessage",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "missing_fields",
    },
    message: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: "90%",
    },
  },

  computed: {
    computedMessage() {
      if (this.message) return this.message
      switch (this.type) {
        case "review_fields":
          return "Review the form above for issues"
        case "missing_fields":
          return "Missing required fields"
        default:
          return "Something went wrong"
      }
    },
  },
}
</script>

<style scoped>
.required-fields-message {
  color: var(--Red-500, #e24646);
  display: flex;
  justify-content: flex-end;
}
</style>
